import { getSession, type AuthSession } from '../api/session';

// Stable keys that scope local data (reading list, home prefs, goals, history,
// library cache) to the signed-in user, mirroring Flutter's ConnectionScopeKey
// (`type|url|userId|libraryId`, lib/domain/entities/connection_scope_key.dart).

const SERVER_TYPE = 'abs';

type ScopeSession = Pick<AuthSession, 'serverUrl' | 'userId'> | null | undefined;

const segment = (value: unknown): string => (value == null ? '' : String(value).trim());

/** `abs|<serverUrl>|<userId>`, or null when signed out. */
export function userScopeKey(session: ScopeSession = getSession()): string | null {
  if (!session) return null;
  return [SERVER_TYPE, session.serverUrl, session.userId].map(segment).join('|');
}

/** `abs|<serverUrl>|<userId>|<libraryId>`, or null when signed out. */
export function libraryScopeKey(libraryId: string | null | undefined, session: ScopeSession = getSession()): string | null {
  if (!session) return null;
  return [SERVER_TYPE, session.serverUrl, session.userId, libraryId].map(segment).join('|');
}
